import { render, staticRenderFns } from "./collecting-case-pool.vue?vue&type=template&id=1ebd646b&scoped=true"
import script from "./collecting-case-pool.vue?vue&type=script&lang=ts"
export * from "./collecting-case-pool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebd646b",
  null
  
)

export default component.exports